import React, { useState, useMemo, useEffect, useRef, useCallback, useContext } from "react";
import { usePersistentState } from '../hooks/usePersistentState';
// import { registerWebPush } from "../actions/hotelActions";
// import { hotelActions } from "../actions/hotelActions";
import useHotelActions from "../hooks/useHotelActions";
import { addSubscriptionDevice } from '../actions/checkInActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import { HotelContext } from "./hotel";
import { UserContext } from "./user"; 
import { CheckInContext } from "./checkin";
import { urlBase64ToUint8Array } from '../globals';
import { T } from "react-translator-component";
import { json } from "react-router-dom";
import { useLocation } from "react-router-dom";

const WebPushContext = React.createContext({})

function WebPushProvider({children}) {
    const publicVapidKey = 'BDsQbQHrRsVU7o-DAlXmzI0yj4N3D0A-No8FRmuik_q2Vdk8qufgB-w4iAGlFt_AGu7sWwLZvOZ0s1XBZ2mCTkM';
    const noShowRequestPermissionModalRoutes = [ "checkin", "checkin/identify", "checkin/welcome" ];
    const { data: { id: hotelId , code : hotelCode } } = useContext(HotelContext);
    const { data: checkIn } = useContext(CheckInContext);
    const { agent } = useContext(UserContext);
    const [ data, setData, setPartialData ] = usePersistentState('webPush', null, 72000)
    const [ permission, setPermission, _, getActualPermission ] = usePersistentState('webPush-permission', null, 72000)
    const [isPWAInstalled, setIsPWAInstalled] = useState(false);
    const { registerWebPush } = useHotelActions();
    const {pathname} = useLocation();

    useEffect(() => {
        const notif = getNotificationObject();
        if (notif?.permission) {
            const actual = getActualPermission();
            let newState = notif.permission;
            if (actual === "ommited" && newState === "default") {
                newState = "ommited";
            }
            setPermission(newState);
        }

    }, [])

    useEffect(() => {
        // Verifica si la PWA está instalada.
        // window.addEventListener('beforeinstallprompt', (e) => {
        //     setIsPWAInstalled(false);
        // });

        // window.addEventListener('appinstalled', () => {
        //     setIsPWAInstalled(true);
        // });

        // return () => {
        //     window.removeEventListener('beforeinstallprompt');
        //     window.removeEventListener('appinstalled');
        // };
    }, []);



    const showRequestPermissionModal = useMemo(() => {
        if (!checkIn?.id) {
            return false;
        }
        let isRouteInNoShowRoutes = false;
        noShowRequestPermissionModalRoutes.map(r => {
            isRouteInNoShowRoutes = isRouteInNoShowRoutes || window.location.pathname.indexOf(r) !== -1;
        })
        return permission === "default" && !isRouteInNoShowRoutes;
    }, [ permission, window.location?.pathname, checkIn?.id ])

    const getNotificationObject = () => {
        if (window.Notification) return window.Notification;
        try {
            return Notification;
        } catch (err) {
            console.log('getNotificationObject', err);
        }
        return null;
    }

    const askNotificationPermission = () => {
        console.log('2711 - useWebPush - askNotificationPermission')
        const notif = getNotificationObject();
        console.log('2711 - useWebPush - notif', notif)
        if (notif) {
            notif.requestPermission().then(result => {
                console.log('2711 - useWebPush - requestPermission() - result', result);
                setPermission(result);
                if (result === 'granted') {
                    getWebPushToken();
                }
            })
        }
    }

    const getWebPushToken = () => {
        console.log('1212 - useWebPush - getWebPushToken')
        console.log('1212 - useWebPush - getWebPushToken TODO::: evaluar si no se envió ya con el local storage');
        navigator.serviceWorker.ready.then((sw) => {
            console.log('1212 -useWebPush - sw', sw)
            sw.pushManager?.subscribe({ userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(publicVapidKey)
                }).then(function(sub) {
                    console.log('1212 -useWebPush - sub', sub)
                    setPartialData({ token: sub })
                    sentWebPushTokenToServer(sub);
                }).catch(function(e) {
                    console.log('subscribe error', e)
                });
        });
    }

    const addTokenToCheckIn = useCallback((webPushId) => {
        console.log('1212 - useWebPush - addTockenToCheckIn');
        console.log('1212 - useWebPush - addTockenToCheckIn - webPushId', webPushId);
        console.log('1212 - useWebPush - addTockenToCheckIn - checkIn.id', checkIn?.id);
        console.log('1212 - useWebPush - addTockenToCheckIn - data?.checkInId', data?.checkInId);
        if (webPushId && ((checkIn?.id !== !data?.checkInId) || (webPushId !== data?.webPushId))) {
            console.log('1212 - useWebPush - addSubscriptionDevice');
            addSubscriptionDevice(checkIn.id, webPushId)
                .then(rSubs => {
                    console.log('1212 - useWebPush - rSubs', rSubs);
                    if (rSubs.status) {
                        console.log('1212 - useWebPush - setted');
                        setPartialData({ checkInId: checkIn.id });
                        // TODO::: parche para que tome las push
                        // sin esto empiezan a funcionar cuando cerramos y abrimos la pwa
                        window.location.reload();
                        // TODO:: ------
                    }
                })
        }
    }, [ checkIn?.id, data?.checkInId ])

    const sentWebPushTokenToServer = (token, webPushId = null) => {
        // let _sendToServer = !data.WebPush?.id;
        // if (!_sendToServer) {
        //     if (data.WebPush?.subscription?.endpoint !== undefined && sub.endpoint !== undefined && data.WebPush.subscription.endpoint !== sub.endpoint) {
        //         _sendToServer = true;
        //     }
        // }
        // if (_sendToServer) {
        console.log('1212 -useWebPush - sentWebPushTokenToServer - hotelId', hotelId)
        console.log('1212 -useWebPush - sentWebPushTokenToServer - webPushId', webPushId)
        console.log('1212 -useWebPush - sentWebPushTokenToServer - agent', agent)
        console.log('1212 -useWebPush - sentWebPushTokenToServer - token', token)
        registerWebPush(hotelId, webPushId, agent, token)
            .then(webPushId => {
                setPartialData({ webPushId: webPushId })
                addTokenToCheckIn(webPushId)
            })
        // }
    }

    const value = {
        permission,
        askNotificationPermission,
        isPWAInstalled
    }

    return <WebPushContext.Provider value={value}>
        {/* <p>WEBPUSH: {permission}</p>
        <br />
        <button type="button" onClick={() => { 
                    const notif = getNotificationObject();
                    alert(notif.permission)
                 }}>Test</button>
                 <button type="button" onClick={() => { 
                    window.location.reload();
                 }}>reload</button> */}
        {children}
        {false && showRequestPermissionModal && pathname !== `/${hotelCode}/settings` && <div id="allow-push-notification-bar" className="shadow">
            <div className="content text-center" style={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1500, background: 'white', border: '1px solid #EEE', padding: '15px' }}>
                <span className="d-block"><FontAwesomeIcon icon={faBell} style={{ fontSize: 50, color: '#3699ff' }} className="mb-2" /></span>
                <div className="text mb-2">
                    {T("notifications.accept")}
                </div>
                <div className="buttons-more">
                    <button type="button" className="btn btn-primary mt-3" onClick={() => { 
                            // setShowRequestPermissionModal(false);
                            askNotificationPermission()
                        }}>
                        {T("notifications.enable")}
                    </button>
                </div>
                <button type="button" className="btn btn-link text-muted" onClick={() => { setPermission('ommited') }}>{T("notifications.not_now")}</button>
            </div>
        </div>}
    </WebPushContext.Provider>
}

const useWebPush = () => {
    return useContext(WebPushContext);
};

export { WebPushProvider, useWebPush }